import { combineReducers } from "redux";
import { i18nReducer } from "react-redux-i18n";
import user from "./user/reducer";
import crossword from "./crossword/reducer";
import levels from "./levels/reducer";
import ui from "./ui/reducer";
import sound from "./sound/reducer";

export default combineReducers({
  i18n: i18nReducer,
  user,
  crossword,
  levels,
  ui,
  sound
});



// WEBPACK FOOTER //
// ./src/reducers/index.js